// @flow

const def: 'default' = 'default';
export default def;

export const error: 'error' = 'error';
export const success: 'success' = 'success';
export const info: 'info' = 'info';
export const warning: 'warning' = 'warning';
